import axios from 'axios';

// v6 finance module — a self-contained axios instance. The host (a vertical admin app, or the
// standalone shell) configures the base URL + token getter once via configureFinanceClient().
// The module NEVER imports the host app's ../api or its auth — everything arrives through props.

let getToken = () => null;

export const financeClient = axios.create();

export function configureFinanceClient({ apiBaseUrl, getToken: tokenGetter } = {}) {
  if (apiBaseUrl != null) financeClient.defaults.baseURL = apiBaseUrl;
  if (typeof tokenGetter === 'function') getToken = tokenGetter;
}

export function assetUrl(path) {
  if (!path) return '';
  if (/^https?:\/\//.test(path)) return path;
  const base = financeClient.defaults.baseURL || '';
  if (path.startsWith('/uploads/')) return `${base}${path}`;
  return path;
}

financeClient.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Normalise every list response to { data, pagination }. The v6 backend returns that envelope;
// older deploys return a bare array (or { data: [...] } with no pagination) — synthesise one so
// the pages render either way.
export function normaliseList(res, requestedLimit) {
  const body = res && res.data;
  let rows = [];
  let pagination = null;
  if (Array.isArray(body)) {
    rows = body;
  } else if (body && Array.isArray(body.data)) {
    rows = body.data;
    pagination = body.pagination || null;
  } else if (body && Array.isArray(body.items)) {
    rows = body.items;
    pagination = body.pagination || null;
  }
  if (!pagination) {
    pagination = { page: 1, total: rows.length, hasMore: false, synthetic: true };
  }
  return { data: rows, pagination, limit: requestedLimit };
}
